
import React from 'react'


class Loading extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" style={this.props.style ? this.props.style : { margin: 'auto', background: 'rgba(255, 255, 255, 0)', display: 'block', width: '35px' }} width="54px" height="54px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
        <g transform="rotate(0 50 50)">
          <rect x="44.5" y="11" rx="5.5" ry="7.0200000000000005" width="11" height="26" fill="#3a97ff">
            <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.7575757575757576s" begin="-0.6734006734006733s" repeatCount="indefinite"></animate>
          </rect>
        </g><g transform="rotate(40 50 50)">
          <rect x="44.5" y="11" rx="5.5" ry="7.0200000000000005" width="11" height="26" fill="#3a97ff">
            <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.7575757575757576s" begin="-0.5892255892255892s" repeatCount="indefinite"></animate>
          </rect>
        </g><g transform="rotate(80 50 50)">
          <rect x="44.5" y="11" rx="5.5" ry="7.0200000000000005" width="11" height="26" fill="#3a97ff">
            <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.7575757575757576s" begin="-0.505050505050505s" repeatCount="indefinite"></animate>
          </rect>
        </g><g transform="rotate(120 50 50)">
          <rect x="44.5" y="11" rx="5.5" ry="7.0200000000000005" width="11" height="26" fill="#3a97ff">
            <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.7575757575757576s" begin="-0.42087542087542085s" repeatCount="indefinite"></animate>
          </rect>
        </g><g transform="rotate(160 50 50)">
          <rect x="44.5" y="11" rx="5.5" ry="7.0200000000000005" width="11" height="26" fill="#3a97ff">
            <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.7575757575757576s" begin="-0.33670033670033667s" repeatCount="indefinite"></animate>
          </rect>
        </g><g transform="rotate(200 50 50)">
          <rect x="44.5" y="11" rx="5.5" ry="7.0200000000000005" width="11" height="26" fill="#3a97ff">
            <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.7575757575757576s" begin="-0.2525252525252525s" repeatCount="indefinite"></animate>
          </rect>
        </g><g transform="rotate(240 50 50)">
          <rect x="44.5" y="11" rx="5.5" ry="7.0200000000000005" width="11" height="26" fill="#3a97ff">
            <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.7575757575757576s" begin="-0.16835016835016833s" repeatCount="indefinite"></animate>
          </rect>
        </g><g transform="rotate(280 50 50)">
          <rect x="44.5" y="11" rx="5.5" ry="7.0200000000000005" width="11" height="26" fill="#3a97ff">
            <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.7575757575757576s" begin="-0.08417508417508417s" repeatCount="indefinite"></animate>
          </rect>
        </g><g transform="rotate(320 50 50)">
          <rect x="44.5" y="11" rx="5.5" ry="7.0200000000000005" width="11" height="26" fill="#3a97ff">
            <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.7575757575757576s" begin="0s" repeatCount="indefinite"></animate>
          </rect>
        </g>
      </svg>
    )
  }
}
export default Loading